module.exports = __webpack_public_path__ + "img/face-emoticon10.e7685f35.svg";